import React, { FC } from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import NcImage from "shared/NcImage/NcImage";
import { IService } from "../../@core/interfaces/IService";
import BtnLikeIcon from "../BtnLikeIcon/BtnLikeIcon";
import { useUsers } from "../../hooks/collections/useUsers";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { UNITS } from "../../@core/constants/units";
import schoonLogo from "images/schoon_transparent.svg";

export interface CarCardHProps {
  className?: string;
  data?: IService & {
    distance?: number;
  };
}

const CarCardH: FC<CarCardHProps> = ({ className = "", data }: CarCardHProps) => {
  const { company, details, distance, images, price, title, id } = data;
  const { toggleFavoriteService } = useUsers({ loadData: false });
  const user = useUserSessionStore(state => state.user);
  const isServiceLiked = user?.favorites?.some(favorite => favorite.id === id) || false;

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (user) toggleFavoriteService(user.id, id);
  }

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full flex items-center justify-center md:w-72 flex-shrink-0 border-r border-neutral-100 dark:border-neutral-800">
        <div className="w-full py-5 sm:py-0">
          <NcImage className="w-full" src={images?.length ? images[0] : schoonLogo}/>
        </div>
        {/*<BtnLikeIcon isLiked={true} className="absolute right-3 top-3" />*/}
        {/*{saleOff && <SaleOffBadge className="absolute left-3 top-3" />}*/}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="flex-grow p-3 sm:p-5 flex flex-col">
        {user && (
          <BtnLikeIcon
            isLiked={isServiceLiked}
            className="absolute right-3 top-3"
            onClick={handleFavoriteClick}
          />
        )}
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            {/*{isAds && <Badge name="ADS" color="green" />}*/}
            <h2 className="text-xl font-semibold capitalize">
              <span className="line-clamp-1">{title}</span>
            </h2>
          </div>
          <div className="flex flex-col justify-center text-sm text-neutral-500 dark:text-neutral-400">
            {/*<StartRating reviewCount={reviewCount} point={reviewStart} />*/}
            {/*<span>· </span>*/}
            <div className="flex items-center">
              <span className="hidden sm:inline-block  text-base">
                <i className="las la-map-marked"></i>
              </span>
              <span className="sm:ml-2 line-clamp-1">{details.location.address}</span>
            </div>
            {distance && (
              <span className="line-clamp-1">
    {distance > UNITS.MILES_TO_METERS
      ? `${(distance / UNITS.MILES_TO_METERS).toLocaleString(undefined, { maximumFractionDigits: 2 })} miles from you`
      : `${(distance / UNITS.YARDS_TO_METERS).toLocaleString(undefined, { maximumFractionDigits: 2 })} yards from you`}
  </span>
            )}
          </div>
        </div>
        {/*<div className="hidden sm:block w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>*/}
        {/* SHOW MOBILE */}
        {/*<div className="flex sm:hidden items-center text-sm text-neutral-500 dark:text-neutral-400 space-x-2 mt-4 sm:mt-0">*/}
        {/*  <span>4 seats</span>*/}
        {/*  <span>· </span>*/}
        {/*  <span>Auto gearbox</span>*/}
        {/*  <span>· </span>*/}
        {/*  <span>4 seats</span>*/}
        {/*</div>*/}
        {/* SHOW DESK */}
        {/*<div className="hidden sm:flex items-center space-x-8">*/}
        {/*  /!* --- *!/*/}
        {/*  <div className="flex items-center space-x-2">*/}
        {/*    <i className="las la-user-friends text-xl"></i>*/}
        {/*    <span className="text-sm text-neutral-500 dark:text-neutral-400">*/}
        {/*      4 seats*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*  /!* --- *!/*/}
        {/*  <div className="flex items-center space-x-2">*/}
        {/*    <i className="las la-dharmachakra text-xl"></i>*/}
        {/*    <span className="text-sm text-neutral-500 dark:text-neutral-400">*/}
        {/*      Auto gearbox*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*  /!* --- *!/*/}
        {/*  <div className="flex items-center space-x-2">*/}
        {/*    <i className="las la-suitcase text-xl"></i>*/}
        {/*    <span className="text-sm text-neutral-500 dark:text-neutral-400">*/}
        {/*      2 bags*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*</div>*/}

        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        <div className="flex justify-between items-end">
          <div className="flex items-center space-x-3 text-sm text-neutral-700  dark:text-neutral-300">
            <Avatar imgUrl={company.imageUrl} userName={company.name}/>
            <span className="hidden sm:inline-block">
              <span className="hidden sm:inline">Service owner: </span>{" "}
              {company.name}
            </span>
          </div>
          <span className="text-lg font-semibold text-secondary-700">
            {price} <span className="text-xs">USD</span>
            {` `}
            <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              /service
            </span>
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-CarCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow will-change-transform ${className}`}
      data-nc-id="CarCardH"
    >
      <Link to={`/service-detail/${id}`} className="flex flex-col md:flex-row">
        {renderSliderGallery()}
        {renderContent()}
      </Link>
    </div>
  );
};

export default CarCardH;
